module.exports = __webpack_public_path__ + "img/icons.40bf741a.svg";